import React from 'react';
import '../styles/WorksheetDetailPage.css';

const KeyPointsTable = ({ keypoints }) => {
  if (!keypoints || Object.keys(keypoints).length === 0) {
    return <div>데이터를 불러오는 중입니다...</div>;
  }

  return (
    <div className="keypoints-container">
      <div className="keypoints-title">지문 핵심 정리</div>
      <table className="keypoints-table">
        <tbody>
          <tr>
            <td className="keypoints-label">제목</td>
            <td className="keypoints-content">{keypoints.title || '데이터 없음'}</td>
          </tr>
          <tr>
            <td className="keypoints-label">주제</td>
            <td className="keypoints-content">{keypoints.topic || '데이터 없음'}</td>
          </tr>
          <tr>
            <td className="keypoints-label">목적</td>
            <td className="keypoints-content">{keypoints.purpose || '데이터 없음'}</td>
          </tr>
          <tr>
            <td className="keypoints-label">세 줄 요약</td>
            <td className="keypoints-content">
              {keypoints.three_sentence_summary
                ? keypoints.three_sentence_summary.split('\n').map((line, index) => (
                    <div key={index}>{line}</div>
                  ))
                : '데이터 없음'}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default KeyPointsTable;